import { render, staticRenderFns } from "./force-change-password.vue?vue&type=template&id=3f2584ca&"
import script from "./force-change-password.vue?vue&type=script&lang=js&"
export * from "./force-change-password.vue?vue&type=script&lang=js&"
import style0 from "./force-change-password.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports